module.exports = __webpack_public_path__ + "static/media/spinning-coin-1.a6b25af6.gif";